import React from 'react';

import FieldController from '../../../controller/FieldController';
import Filter from '../../filter/FilterPannel';

import AutomationAssigmnentItem from './AutomationAssigmnentItem';

class AutomationAssigmnent extends React.Component {

  constructor(props) {
    super(props);
    this.fields = [];
    for(let i = 0; i < props.fields.length; i++) {
      if(props.fields[i].fieldKey === 'responsible_person'
        || props.fields[i].fieldKey === 'status') continue;
      this.fields.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
        type: props.fields[i].field_type, label: props.fields[i].label_name });
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(this.props.module !== props.module) {
      this.fields = [];
      for(let i = 0; i < props.fields.length; i++) {
        if(props.fields[i].fieldKey === 'responsible_person'
          || props.fields[i].fieldKey === 'status') continue;
        this.fields.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
          type: props.fields[i].field_type, label: props.fields[i].label_name });
      }
    }
  }

  render() {
    const assigments = this.props.assigments.map(assigment => {
      let field = this.fields.find(field => field.value === assigment.field);
      let value = assigment.value;
      if(field !== undefined) {
        const isText = FieldController.showTextFilter(field.type, Filter.Equals);
        if(!isText) {
          const options = FieldController.getOptions(this.props.model.fields[field.value], field.value);
          value = options.find(option => option.value === assigment.value);
        }
      }
      return { field, value };
    });

    return assigments.map((assigment, i) => 
      <AutomationAssigmnentItem key={`automation_assigmnent_${i}`}
        index={i} value={assigment} fields={this.fields} model={this.props.model}
        onAdd={this.props.onAdd} onEdit={this.props.onEdit} onDelete={this.props.onDelete} />
    );
  }
}
export default AutomationAssigmnent;